import { registerAction } from '../../Action'

const SET_SEARCH_TERM = 'SET_SEARCH_TERM'

const reducer = (state = {}, action) => ({
  ...state,
  searchTerm: action.payload,
})

const setSearchTerm = registerAction(SET_SEARCH_TERM, { reducer })

export default setSearchTerm
